import { ISagaModule } from 'redux-dynamic-modules-saga';
import reducer from './reducer';
import { giftingSaga } from './saga';
import { reduxInitialized } from './actions';

export function getGiftingModule(): ISagaModule<any> {
  return {
    id: 'giftingModule',
    reducerMap: reducer,
    initialActions: [reduxInitialized()],
    sagas: [giftingSaga],
    retained: true,
  };
}
